import { render } from "./SetRegistrationDateModal.vue?vue&type=template&id=0a225274&scoped=true&ts=true&lang=pug"
import script from "./SetRegistrationDateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetRegistrationDateModal.vue?vue&type=script&setup=true&lang=ts"

import "./SetRegistrationDateModal.vue?vue&type=style&index=0&id=0a225274&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a225274"]])

export default __exports__